<template>
    <div>
        <v-layout row wrap xs12>
            <h3>Langues :</h3>
            <hr size="5" width="100%" color="secondary">
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="50%">
                <template v-slot:activator="{ on }">
                    <v-layout align-start justify-end>
                        <v-btn style="min-width: 0; margin-bottom:0; margin-top:0"
                               color="primary"
                               small
                               dark
                               v-on="on">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Add' : 'Ajouter'}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-card>
                    <v-toolbar color="cyan darken-4" dark>
                        <v-toolbar-title>Ajouter langue</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap xs12>
                                <v-flex xs4>
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.TypeLangueList"
                                                    v-model="editedItem.Type"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Level': 'Niveau'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.LangueList"
                                                    v-model="editedItem.Langue"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Language': 'Langue'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4 class="pl-3">
                                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Degree': 'Diplôme'" v-model="editedItem.Diplome"></v-switch>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap xs12 v-if="editedItem.Diplome">
                                <v-flex xs4>
                                    <v-text-field v-model="editedItem.NomDiplome"
                                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Degree name' : 'Nom diplôme obtenu'">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeObtentionList"
                                                    v-model="editedItem.AnneeDiplome"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex>
                                    <v-text-field v-model="editedItem.Score"
                                                  label="Score" type="number">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$storeCandidature.langueFormulaire == 'en' ? 'Cancel' : 'Annuler'}}</v-btn>
                        <v-btn color="blue darken-1" flat @click="save">{{$storeCandidature.langueFormulaire == 'en' ? 'Validate' : 'Valider'}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- fin dialog -->
        </v-layout>
        <!-- Début Liste langues -->
        <v-data-table :headers="headers" :items="$storeCandidature.sasCandidature.ListeLangues" class="elevation-1" disable-pagination hide-default-footer>
            <template v-slot:no-data>
                <v-alert :value="true" color="grey lighten-3" icon="warning">{{$storeCandidature.langueFormulaire == 'en' ? 'List empty' : 'La liste est vide'}}</v-alert>
            </template>
            <template v-slot:item={item}>
                <tr v-if="!item.Supprimer">
                    <th class="text-xs-left">{{ item.Type ? ($storeCandidature.langueFormulaire == 'en' ? item.Type.Lang01 : item.Type.Lang00) : ''}}</th>
                    <th class="text-xs-left">{{ item.Langue ? ($storeCandidature.langueFormulaire == 'en' ?  item.Langue.Lang01 : item.Langue.Lang00 ): '' }}</th>
                    <th>
                        <v-checkbox v-model="item.Diplome" hide-details></v-checkbox>
                    </th>
                    <th class="text-xs-left">{{ item.NomDiplome}}</th>
                    <th class="text-xs-left">{{ item.AnneeDiplome ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeDiplome.Lang01 : item.AnneeDiplome.Lang00) : '' }}</th>
                    <th class="text-xs-left">{{ item.Score}}</th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                        <v-icon small @click="deleteItem(item)">delete</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,

                // Dialig et Header list
                dialog: false,                
                headers: [
                    { text: 'Type', value: 'type' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Language' : 'Langue', value: 'langue' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree name' : 'Nom dipôme', value: 'nomdiplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Year' : 'Année', value: 'annee' },
                    { text: 'Score', value: 'score' },
                    { text: '', value: 'actions', sortable: false }
                ],

                editedIndex: -1,
                editedItem: {
                    Type: null,
                    Langue: null,
                    Diplome: false,
                    NomDiplome: '',
                    AnneeDiplome: null,
                    Score: '',
                    Supprimer: false
                },
            }
        },

        methods: {
            editItem(item) {
                this.editedIndex = this.$storeCandidature.sasCandidature.ListeLangues.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {
                if (confirm(this.$storeCandidature.langueFormulaire == 'en' ? 'Are you sure you want to delete the language?' : 'Etes-vous sûr de vouloir supprimer la langue ?')) {
                    this.editedIndex = this.$storeCandidature.sasCandidature.ListeLangues.indexOf(item)
                    this.editedItem.Supprimer = true;
                    Object.assign(this.$storeCandidature.sasCandidature.ListeLangues[this.editedIndex], this.editedItem)
                    this.$storeCandidature.candidatureChanged = true
                }
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, {
                        Type: null,
                        Langue: null,
                        Diplome: false,
                        NomDiplome: '',
                        AnneeDiplome: null,
                        Score: '',
                        Supprimer: false
                    })
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                if (this.editedIndex > -1) {
                    Object.assign(this.$storeCandidature.sasCandidature.ListeLangues[this.editedIndex], this.editedItem)
                } else {
                    this.$storeCandidature.sasCandidature.ListeLangues.push(this.editedItem)
                }
                this.$storeCandidature.candidatureChanged = true
                this.close()
            },
        },
    }
</script>

